<ng-container *ngIf="dataState$ | async as dataState">
  <div *ngIf="dataState.users.length" class="result-list">
    <h1 class="search-results-label">{{ '+SEARCH.RESULT_LIST.SEARCH_RESULT' | translate }}</h1>
    <div class="list-item-header flex flex-row justify-start items-center lt-lg:!hidden">
      <div class="num" data-at-column-number>
        {{ '+SEARCH.RESULT_LIST.LABEL.NUMBER' | translate }}
      </div>
      <div class="type" data-at-column-userType>
        {{ '+SEARCH.RESULT_LIST.LABEL.TYPE' | translate }}
      </div>
      <div class="userid" data-at-column-userId>
        {{ '+SEARCH.RESULT_LIST.LABEL.USER_ID' | translate }}
      </div>
      <div class="name flex flex-row">
        <div class="flex-[150px] max-w-[150px]" data-at-column-firstName>
          {{ '+SEARCH.SEARCH_BY_USER.OPTION_SEARCH.PLACEHOLDER.FIRST_NAME' | translate }}
        </div>
        <div class="flex-[230px] max-w-[230px]" data-at-column-familyName>
          {{ '+SEARCH.SEARCH_BY_USER.OPTION_SEARCH.PLACEHOLDER.FAMILY_NAME' | translate }}
        </div>
      </div>
      <div class="role flex flex-row" data-at-column-role>
        <div>{{ '+SEARCH.RESULT_LIST.LABEL.ROLE' | translate }}</div>
      </div>
    </div>
    <app-infinite-scroll
      [state$]="dataState$"
      [search$]="searchService.search$"
      [itemSize]="itemSize"
      (fetchNext)="onFetchNext($event)"
      [(nextBatch)]="nextBatch"
      (nextBatchChange)="onNextBatchChange($event)"
      [limit]="100"
    >
      <cdk-virtual-scroll-viewport
        [style.height.px]="
          ((uIService.isMobileView$ | async) ? 66 : 0) +
          getViewportHeight(dataState?.users?.length, itemSize, 1)
        "
        [itemSize]="itemSize"
      >
        <div
          data-at-user-list-header
          class="list-item-header !hidden lt-lg:!flex flex-row justify-start items-center"
        >
          <div class="num">No.</div>
          <div class="type">
            {{ '+SEARCH.RESULT_LIST.LABEL.TYPE' | translate }}
          </div>
          <div class="userid">
            {{ '+SEARCH.RESULT_LIST.LABEL.USER_ID' | translate }}
          </div>
          <div class="name flex flex-row">
            <div class="flex-[150px] max-w-[150px]">
              {{ '+SEARCH.SEARCH_BY_USER.OPTION_SEARCH.PLACEHOLDER.FIRST_NAME' | translate }}
            </div>
            <div class="flex-[230px] max-w-[230px]">
              {{ '+SEARCH.SEARCH_BY_USER.OPTION_SEARCH.PLACEHOLDER.FAMILY_NAME' | translate }}
            </div>
          </div>
          <div class="role flex flex-row">
            <div>{{ '+SEARCH.RESULT_LIST.LABEL.ROLE' | translate }}</div>
          </div>
        </div>
        <div
          class="list-item-element flex flex-row justify-start items-center"
          *cdkVirtualFor="let item of dataState.users; let index = index"
          gtm="onGoToPage"
          gtmAction="User details"
          gtmCategory="search"
          (click)="navigateTo(item._id ?? item.id)"
          data-at-user-list-item
        >
          <div class="num">
            {{ index + 1 }}
          </div>
          <div class="type flex flex-row justify-start items-center">
            <mat-icon class="type-icon">face</mat-icon>
            <div>{{ '+SEARCH.SEARCH_BY_USER.TITLE' | translate }}</div>
          </div>
          <div data-at-username class="userid break-word">
            {{ item.loginId }}
          </div>
          <div class="name flex flex-row">
            <div data-at-first-name class="break-word flex-[150px] max-w-[150px]">
              {{ item.name?.firstName }}
            </div>
            <div data-at-family-name class="break-word flex-[230px] max-w-[230px]">
              {{ item.name?.familyName }}
            </div>
          </div>
          <div data-at-user-role class="role flex flex-row">
            <div>{{ item.properties | getUserRole }}</div>
          </div>
        </div>
        <vi-loader
          *ngIf="nextBatch"
          [isLoading]="true"
          [message]="'+SEARCH.RESULT_LIST.FETCHING_MORE_RESULTS' | translate"
        ></vi-loader>
      </cdk-virtual-scroll-viewport>
    </app-infinite-scroll>
  </div>
  <vi-no-results
    imgPath="assets/img/search-guy.png"
    *ngIf="dataState.loaded && (!dataState.users || !dataState?.users?.length)"
  >
    {{ '+SEARCH.RESULT_LIST.USER_NOT_FOUND' | translate }}
  </vi-no-results>
</ng-container>
